import Widget from "views/logic/widgets/Widget";
import pivotForField from "views/logic/searchtypes/aggregation/PivotGenerator";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Series from "views/logic/aggregationbuilder/Series";
import DataTable from "views/components/datatable";
import { addWidget } from "views/logic/slices/widgetActions";
import duplicateCommonWidgetSettings from "./DuplicateCommonWidgetSettings";
const AggregateActionHandler = ({ field, type, contexts: { widget = Widget.empty() } }) => (dispatch) => {
  const newWidgetBuilder = AggregationWidget.builder().newId().config(
    AggregationWidgetConfig.builder().rowPivots([pivotForField(field, type)]).series([Series.forFunction("count()"), Series.forFunction("percentage()")]).visualization(DataTable.type).build()
  );
  const newWidget = duplicateCommonWidgetSettings(newWidgetBuilder, widget).build();
  return dispatch(addWidget(newWidget));
};
export default AggregateActionHandler;
